import moment from "moment";

export const getFormattedDate = (date: Date) => {
  if (!date) return "";
  return moment.utc(date).format("DD-MMM-YYYY");
};

export const getFormattedTime = (time: Date) => {
  if (!time) return "";
  return moment.utc(time).format("h:mm A");
};
